import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'center-canvas',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    CommonModule
],
  templateUrl: './center-canvas.component.html',
  styleUrl: './center-canvas.component.scss'
})
export class CenterCanvasComponent {
  @Input() centerAction!: Function;
}
